module.exports = __webpack_public_path__ + "static/img/maybank-logo-png-transparent.a33aee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maybank-logo-png-transparent.png
// module id = BYt1
// module chunks = 62